import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getManagementPositionList,
	addNewManagementPosition,
	updateManagementPosition,
	deleteManagementPosition,
	getManagementPosition,
	getOrganizationalChart,
} from '../managementPosition/thunk';

export const initialState = {
	itemManagementPositionList: [],
	itemManagementPositionDetail: null,
	isManagementPositionLoading: false,
	isManagementPositionSuccess: false,

	managementPositionList: [],
	managementPositionListSelect: [],
	itemOrganizationalChart: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ManagementPositionSlice = createSlice({
	name: 'ManagementPositions',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getManagementPosition.fulfilled, (state, action) => {
			state.isManagementPositionLoading = false;
			state.isManagementPositionSuccess = true;
			state.itemManagementPositionDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getManagementPosition.pending, state => {
			state.isManagementPositionLoading = true;
			state.isManagementPositionSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagementPosition.rejected, (state, action) => {
			state.isManagementPositionLoading = false;
			state.isManagementPositionSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getManagementPositionList.pending, state => {
			state.isManagementPositionSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getManagementPositionList.fulfilled, (state, action) => {
			state.itemManagementPositionList = action.payload;
			state.managementPositionList = action.payload;
			state.isLoadingList = false;
			state.isManagementPositionSuccess = true;

			let managementPositionListSelect = [];
			action.payload.map(item =>
				managementPositionListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.managementPositionListSelect = managementPositionListSelect;
		});
		builder.addCase(getManagementPositionList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isManagementPositionSuccess = true;
		});
		builder.addCase(addNewManagementPosition.fulfilled, (state, action) => {
			state.itemManagementPositionList.push(action.payload);
			state.managementPositionList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewManagementPosition.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewManagementPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateManagementPosition.fulfilled, (state, action) => {
			state.itemManagementPositionList = state.itemManagementPositionList.map(managementPosition =>
				managementPosition.managementPositionname === action.payload.old_managementPosition
					? { ...managementPosition, ...action.payload.updated_managementPosition }
					: managementPosition
			);
			state.managementPositionList = state.managementPositionList.map(managementPosition =>
				managementPosition._id.toString() === action.payload._id.toString()
					? { ...managementPosition, ...action.payload }
					: managementPosition
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateManagementPosition.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateManagementPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteManagementPosition.fulfilled, (state, action) => {
			state.itemManagementPositionList = current(state.itemManagementPositionList).filter(
				item => item._id !== action.payload._id
			);
			state.managementPositionList = current(state.managementPositionList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteManagementPosition.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteManagementPosition.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});



		builder.addCase(getOrganizationalChart.fulfilled, (state, action) => {
			state.isManagementPositionLoading = false;
			state.isManagementPositionSuccess = true;
			state.itemOrganizationalChart = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getOrganizationalChart.pending, state => {
			state.isManagementPositionLoading = true;
			state.isManagementPositionSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getOrganizationalChart.rejected, (state, action) => {
			state.isManagementPositionLoading = false;
			state.isManagementPositionSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});
	},
});

export const { setRequireCloseModal } = ManagementPositionSlice.actions;

export default ManagementPositionSlice.reducer;
